import React from "react"
import HeadingL from "../../components/shared/HeadingL"
import Layout from "../../components/sutea/Layout"
import SEO from "../../components/Seo"
import { PAGE } from "../../constants"
import AssessmentPage from "../../components/sutea/AssessmentPage"

const assessment = () => (
  <Layout>
    <SEO title={PAGE.title.assessment} siteTitle="すてあ" />
    <HeadingL title={PAGE.title.assessment} target="sutea" />
    <AssessmentPage />
  </Layout>
)

export default assessment
